<template>
  <div class="container">
    <div
      :class="theModel === 1 ? 'active' : ''"
      @click="$emit('update:modelValue', 1)"
      class="tab"
    >
      <svg
        width="12"
        height="12"
        viewBox="0 0 12 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.4333 6.05569C10.4319 5.79585 10.4077 5.53664 10.361 5.28103L11.3713 4.58103C11.4821 4.50383 11.5598 4.38788 11.5892 4.25609C11.6186 4.12431 11.5975 3.9863 11.53 3.86936L10.6666 2.36436C10.5992 2.2462 10.4894 2.15806 10.3594 2.11777C10.2295 2.07749 10.0891 2.08806 9.96663 2.14736L8.85363 2.67236C8.45786 2.34105 8.00687 2.08199 7.5213 1.90703L7.41863 0.675026C7.40696 0.540713 7.34537 0.41565 7.24602 0.32451C7.14668 0.23337 7.01678 0.18277 6.88196 0.182693H5.14596C5.00954 0.18041 4.87733 0.229951 4.77599 0.321322C4.67466 0.412693 4.61176 0.539094 4.59996 0.675026L4.50663 1.90703C4.02105 2.08199 3.57006 2.34105 3.17429 2.67236L2.0613 2.14736C1.93884 2.08806 1.79844 2.07749 1.66849 2.11777C1.53853 2.15806 1.42873 2.2462 1.3613 2.36436L0.497962 3.86703C0.430467 3.98396 0.409318 4.12198 0.438699 4.25376C0.46808 4.38554 0.545852 4.5015 0.656628 4.57869L1.66696 5.27869C1.62027 5.53431 1.59606 5.79352 1.59463 6.05336C1.59618 6.3101 1.62038 6.56621 1.66696 6.81869L0.656628 7.51869C0.545852 7.59588 0.46808 7.71184 0.438699 7.84363C0.409318 7.97541 0.430467 8.11342 0.497962 8.23036L1.36596 9.73303C1.4338 9.85078 1.54361 9.93856 1.67341 9.9788C1.80321 10.019 1.94342 10.0088 2.06596 9.95003L3.17196 9.42969C3.56995 9.76328 4.02322 10.0247 4.5113 10.202L4.59996 11.4224C4.6112 11.5587 4.67386 11.6857 4.77525 11.7775C4.87664 11.8694 5.00917 11.9193 5.14596 11.917H6.87963C7.01482 11.9169 7.14502 11.866 7.24443 11.7743C7.34383 11.6827 7.40518 11.5571 7.4163 11.4224L7.51896 10.2044C8.0072 10.0273 8.46053 9.76593 8.8583 9.43203L9.96663 9.95236C10.0892 10.0111 10.2294 10.0214 10.3592 9.98113C10.489 9.94089 10.5988 9.85311 10.6666 9.73536L11.5346 8.23269C11.6012 8.11467 11.6209 7.9759 11.5898 7.84401C11.5586 7.71213 11.479 7.59681 11.3666 7.52103L10.3586 6.82103C10.4048 6.56845 10.4298 6.31244 10.4333 6.05569ZM6.01396 7.99469C5.6298 7.99515 5.25415 7.88163 4.93454 7.66849C4.61493 7.45535 4.36574 7.15218 4.21852 6.79735C4.07129 6.44253 4.03265 6.052 4.10749 5.6752C4.18232 5.2984 4.36726 4.95227 4.6389 4.68063C4.91054 4.40899 5.25667 4.22405 5.63347 4.14922C6.01027 4.07438 6.4008 4.11302 6.75562 4.26025C7.11045 4.40747 7.41362 4.65666 7.62676 4.97627C7.8399 5.29588 7.95342 5.67153 7.95296 6.05569C7.95234 6.56976 7.74786 7.06259 7.38436 7.42609C7.02086 7.78959 6.52803 7.99407 6.01396 7.99469Z"
        />
      </svg>
      Player Configuration
    </div>
    <div
      :class="theModel === 2 ? 'active' : ''"
      @click="$emit('update:modelValue', 2)"
      class="tab"
    >
      <svg
        width="14"
        height="10"
        viewBox="0 0 14 10"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M8.09589 0.67114C7.77338 0.584725 7.44189 0.776114 7.35547 1.09862L5.24316 8.9819C5.15674 9.3044 5.34813 9.6359 5.67063 9.72231C5.99314 9.80873 6.32463 9.61734 6.41105 9.29483L8.52337 1.41155C8.60978 1.08905 8.41839 0.757555 8.09589 0.67114ZM0.413826 4.91054L3.15601 2.15934C3.3973 1.91726 3.78935 1.91726 4.03064 2.15934C4.27082 2.4003 4.27082 2.79014 4.03064 3.03111L1.72148 5.34786L4.03064 7.66462C4.27082 7.90558 4.27082 8.29542 4.03064 8.53639C3.78935 8.77847 3.3973 8.77847 3.15601 8.53639L0.413826 5.78518C0.173093 5.54366 0.173093 5.15207 0.413826 4.91054ZM13.3527 5.78519L10.6105 8.53639C10.3692 8.77848 9.9772 8.77848 9.73591 8.53639C9.49574 8.29543 9.49574 7.90559 9.73591 7.66463L12.0451 5.34787L9.73591 3.03111C9.49574 2.79015 9.49574 2.40031 9.73591 2.15935C9.9772 1.91726 10.3692 1.91726 10.6105 2.15935L13.3527 4.91055C13.5935 5.15208 13.5935 5.54366 13.3527 5.78519Z"
        />
      </svg>
      Code Preview
    </div>
  </div>
</template>

<script>
import { computed } from "vue";
export default {
  setup(props, { emit }) {
    const theModel = computed({
      // Use computed to wrap the object
      get: () => props.modelValue,
      set: (value) => emit("update:modelValue", value),
    });

    return { theModel };
  },
  props: {
    modelValue: {
      type: Number,
      default: 1,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/container.scss";
.container {
  margin: 0 0 $space - 4px 0;
  padding: 0;

  .tab {
    display: flex;
    align-items: center;
    column-gap: 5.4px;
    padding: $space $space * 2;
    position: relative;
    cursor: pointer;
    font-weight: 500;
    color: $grey-800;
    font-size: $base-font-size + 2px;
    border-bottom: 2px solid transparent;
    svg {
      fill: $grey-800;
    }
    &.active {
      color: $ci-primary;
      border-bottom: 2px solid $ci-primary;
      cursor: default;
      svg {
        fill: $ci-primary;
      }
    }
  }
}
</style>
